module.exports = __webpack_public_path__ + "img/skiing002.864557ad.jpg";